import { useTranslation } from 'react-i18next';
import styles from './LanguageSwitcher.module.css';

const LANGS = [
  { code: 'pt-BR', short: 'PT' },
  { code: 'en-US', short: 'EN' },
  { code: 'es', short: 'ES' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language;

  return (
    <div className={styles.wrap}>
      {LANGS.map((l) => (
        <button
          key={l.code}
          className={styles.lang}
          data-active={current === l.code}
          onClick={() => i18n.changeLanguage(l.code)}
        >
          {l.short}
        </button>
      ))}
    </div>
  );
}
